export const messages = {
  required: 'Campo obrigatório',
  mustBeNumber: 'O valor deve ser um número',
  mustBePositive: 'O valor deve ser maior que zero',
  mustBeInteger: 'O valor deve ser um número inteiro',
  noNegative: 'O valor não pode ser negativo',
  minItems: 'Adicione pelo menos um item',
};
